import { useTranslation } from "react-i18next"

import { StatusBadge } from "@/components/status-badge"
import {
  bucketForOrderStatus,
  bucketTone,
} from "@/features/orders/lib/order-status"

export function OrderStatusBadge({ status }: { status?: string | null }) {
  const { t } = useTranslation("orders")
  const bucket = bucketForOrderStatus(status)
  if (!bucket) return null
  return (
    <StatusBadge tone={bucketTone(bucket)}>
      {t(`statusBucket.${bucket}`)}
    </StatusBadge>
  )
}
